/**
 * Add mute/unmute button to custom header video.
 */
export default () => {
  document.addEventListener('wp-custom-header-video-loaded', () => {
    if (! window.wp.customHeader.handlers.nativeVideo) {
      return;
    }

    const videoContainer = window.wp.customHeader.handlers.nativeVideo.container;
    if (! videoContainer) {
      return;
    }

    const l10n = window.wp.customHeader.handlers.nativeVideo.settings.l10n;
    if (! l10n.mute || ! l10n.unmute) {
      return;
    }

    const button = document.createElement('button');
    button.innerHTML = l10n.unmute;
    button.classList.add('wp-custom-header-video-button');
    button.classList.add('wp-custom-header-video-mute');
    videoContainer.appendChild(button);

    const video = videoContainer.querySelector('video');
    button.onclick = () => {
      video.muted = ! video.muted;
      button.innerHTML = video.muted ? l10n.unmute : l10n.mute;
      if ('a11y' in window.wp) {
        if (video.muted) {
          window.wp.a11y.speak(l10n.muteSpeak);
        } else {
          window.wp.a11y.speak(l10n.unmuteSpeak);
        }
      }
    };
  });
};
